const BookIds = {
  BACH_TAKES_A_WALK: 'ereader.bach_takes_a_walk',
  BECAME_AMERICANS: 'ereader.became_americans',
  BEST_PRESENT: 'ereader.best_present',
  BIG_RIDE: 'ereader.big_ride',
  BUSY_WOLF: 'ereader.busy_wolf',
  CAN_I_GET_A_SIP: 'ereader.can_i_get_a_sip',
  CAT_ROOSTER_MOUSE: 'ereader.cat_rooster_mouse',
  CHANGING_SOCIAL_STRUCTURES: 'ereader.changing_social_structures',
  CHERRY_TREE: 'ereader.cherry_tree',
  CREATED_EQUAL: 'ereader.created_equal',
  DANCING_BEE: 'ereader.dancing_bee',
  DARK_SIDE_OF_MOON: 'ereader.dark_side_of_moon',
  DOG_HAS_A_NOSE: 'ereader.dog_has_a_nose',
  EASY_PEAS: 'ereader.easy_peas',
  EGG_HATCHES: 'ereader.egg_hatches',
  FIVE_SENSES: 'ereader.five_senses',
  FOUR_NATIVE_AMERICAN_WOMEN: 'ereader.four_native_american_women',
  FREEZE_OUT: 'ereader.freeze_out',
  GYM_CLASS: 'ereader.gym_class',
  HEDGEHOG_AND_FOX: 'ereader.hedgehog_and_fox',
  HUNT_FOR_RAGNARS_SCIMITAR: 'ereader.hunt_for_ragnars_scimitar',
  JUMP_ROPE: 'ereader.jump_rope',
  LIFTING_UP_THE_SKY: 'ereader.lifting_up_the_sky',
  LITTLE_HERCULES: 'ereader.little_hercules',
  LITTLE_MOUSE_ANIMALS: 'ereader.little_mouse_animals',
  NICHOLAS_BROTHERS: 'ereader.nicholas_brothers',
  ONCE_UPON_A_SWING: 'ereader.once_upon_a_swing',
  PEOPLE_OF_RENAISSANCE: 'ereader.people_of_renaissance',
  POP_IN_TIME: 'ereader.pop_in_time',
  ROBOT_GIRL_MYSTERY: 'ereader.robot_girl_mystery',
  SAM_MAKES_A_FRIEND: 'ereader.sam_makes_a_friend',
  SKIN_WE_ARE_IN: 'ereader.skin_we_are_in',
  SPACEWALKS: 'ereader.spacewalks',
  VOLCANOES_EXPLOSIONS: 'ereader.volcanoes_explosions',
  WARTHOG_KNEES: 'ereader.warthog_knees',
  WHERE_AM_I: 'ereader.where_am_i',
  WHERE_IS_MR_NIBBLES: 'ereader.where_is_mr_nibbles',
};

export const spanishBookIds = {
  AVENTURA_BARRIO: 'ereader.aventura_barrio',
  BERNARDO_HERO: 'ereader.bernardo_hero',
  CAMBIA_PLANTA: 'ereader.cambia_planta',
  CAPIBARA_ANIMAL: 'ereader.capibara_animal',
  CROAN_RANAS: 'ereader.croan_ranas',
  DESEOS_SOL: 'ereader.deseos_sol',
  DIA_INDEPENDENCIA: 'ereader.dia_independencia',
  DIFERENTES_IGUALES: 'ereader.diferentes_iguales',
  DOLORES_HUERTA: 'ereader.dolores_huerta',
  DONDE_TINA: 'ereader.donde_tina',
  EFFECTO_MARIPOSA: 'ereader.effecto_mariposa',
  ESTACIONES_TIEMPO: 'ereader.estaciones_tiempo',
  FASCINANTES_RUTAS: 'ereader.fascinantes_rutas',
  FESTIN_SABORES: 'ereader.festin_sabores',
  HORMIGAS_AMIGAS: 'ereader.hormigas_amigas',
  LAS_MARIPOSAS: 'ereader.las_mariposas',
  LA_DESPEDIDA: 'ereader.la_despedida',
  LEYENDA_COLIBRI: 'ereader.leyenda_colibri',
  LOS_ALUXES: 'ereader.los_aluxes',
  MARIA_EXPLORADORA: 'ereader.maria_exploradora',
  POP_TIEMPO: 'ereader.pop_tiempo',
  PUEDES_HACER: 'ereader.puedes_hacer',
  QUETZAL_DORADO: 'ereader.quetzal_dorado',
  RUIDOSO_CUERPO: 'ereader.ruidoso_cuerpo',
  SEMILLA_FLOR: 'ereader.semilla_flor',
  VERDADERA_FORTUNA: 'ereader.verdadera_fortuna',
  ZORRO_HUAYCHAO: 'ereader.zorro_huaychao',
};

export default {
  ...BookIds,
  ...spanishBookIds,
};
